import { API_AUTH_RESET } from "../../constants/API";
import {
  CAMERAS_CLEAR_PANE,
  CAMERAS_SET_CURRENT_CAMERA
}                         from "../../constants/cameras";
import {
  concatByTime,
  StripType
} from "../../utils";
import initialState       from './initialState';
import {
  BrowseAction,
  BrowseState
}                         from "./types";

const reducer = (state: BrowseState = initialState, action: BrowseAction) => {
  switch (action.type) {

    case('resetTimestrips'):
      return {
        ...state,
        browsePanes: {
          ...state.browsePanes,
          0: {
            ...state.browsePanes[0],
            data: null
          },
          1: {
            ...state.browsePanes[1],
            data: null
          }
        }
      };

    case('startBrowsePane'): {
      return {
        ...state,
        browsePanes: {
          ...state.browsePanes,
          [action.pane]: {}
        }
      }
    }
    case('initBrowsePane'): {
      return {
        ...state,
        browsePanes: {
          ...state.browsePanes,
          [action.pane]: {
            ...state.browsePanes[action.pane],
            inited: true,
            error: false,
            success: false,
            id: action.id,
            timeStripError: false
          }
        }
      };
    }

    case('fetchBrowsePane'):
      return {
        ...state,
        browsePanes: {
          ...state.browsePanes,
          [action.pane]: {
            ...state.browsePanes[action.pane],
            fetch: true,
            inited: false,
          }
        }
      };

    case('errorBrowsePane'):
      return {
        ...state,
        browsePanes: {
          ...state.browsePanes,
          [action.pane]: {
            error: true,
            fetch: false,
            inited: false
          }
        }
      };

    case('successBrowsePane'):
      return {
        ...state,
        browsePanes: {
          ...state.browsePanes,
          [action.pane]: {
            ...state.browsePanes[action.pane],
            success: true,
            error: false,
            fetch: false,
            inited: false
          }
        }
      };

    case('resetBrowsePanes'):
      return {
        ...state,
        browsePanes: {}
      };

    case('browseAddTimeStrips'): {
      const {pane, strips, continuation_id} = action;
      const reloadTimestrips = state.reloadTimestrips + 1;
      let newStrips = strips;
      if (continuation_id === 'bkmks' && strips) {
        newStrips = [...state.browsePanes[pane].timestrips.filter((s: StripType) => s.type !== 0), ...strips];
      }

      return {
        ...state,
        reloadTimestrips: reloadTimestrips,
        browsePanes: {
          ...state.browsePanes,
          [pane]: {
            ...state.browsePanes[pane],
            timestrips: newStrips,
            timeStripFetch: false,
            continuation_id: continuation_id
          }
        }
      };
    }

    case('browseErrorTimeStrips'): {
      const {pane} = action;
      return {
        ...state,
        browsePanes: {
          ...state.browsePanes,
          [pane]: {
            ...state.browsePanes[pane],
            timeStripFetch: false,
            timeStripError: true
          }
        }
      };
    }

    case('browseFetchTimeStrips'): {
      const {pane} = action;
      return {
        ...state,
        browsePanes: {
          ...state.browsePanes,
          [action.pane]: {
            ...state.browsePanes[pane],
            timeStripFetch: true
          }
        }
      };
    }

    case('browseEndFetchTimeStrips'): {
      return {
        ...state,
        browsePanes: {
          ...state.browsePanes,
          [action.pane]: {
            ...state.browsePanes[action.pane],
            timeStripFetch: false
          }
        }
      };
    }

    case('browseAddCameraBookmarks'): {
      return {
        ...state,
        browsePanes: {
          ...state.browsePanes,
          [action.pane]: {
            ...state.browsePanes[action.pane],
            bookmarks: action.bookmarks
          }
        }
      }
    }

    case('setCurrentLayout'):
      return {
        ...state,
        browsePanes: {}
      };

    case CAMERAS_SET_CURRENT_CAMERA: {
      const {pane} = action;
      // delete state.browsePanes[pane];

      return {
        ...state,
        reloadTimestrips: state.reloadTimestrips++,
      };
    }

    case('setDraggableCamId'):
      return {
        ...state,
        draggableCamId: action.draggableCamId
      };

    case('@@router/LOCATION_CHANGE'):
      return {
        ...state,
        browsePanes: {}
      };

    case API_AUTH_RESET :
      return {
        ...initialState,
      };

    case CAMERAS_CLEAR_PANE : {
      return {
        ...state,
        browsePanes: {
          ...state.browsePanes,
          [action.pane]: {}
        }
      };
    }


    default:
      return state
  }
};

export default reducer